import { Empty, message, Skeleton } from 'antd'
import SettingsCard from 'egi/app/Settings/components/SettignsCard/SettingsCard'
import SettingsHistory from 'egi/app/Settings/components/SettignsHistory/SettingsHistory'
import PartnerApiRepository from 'egi/repositories/PartnerApiRepository'
import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import masks from 'utils/masks'
import CallbackFieldsSection from './components/CallbackFieldsSection'
import CallbackSection from './components/CallbackSection'
import PartnerApiLogs from './components/PartnerApiLogs'
import PartnerTokenSection from './components/PartnerTokenSection'
import ServicesSection from './components/ServicesSection'
import { IPartnerDetail, PartnerUpdateBody } from './partnerApiCredentials'

export default function PartnerApiEdit () {
  const { promoterId } = useParams<{ promoterId: string }>()
  const [promoter, setPromoter] = useState<IPartnerDetail>()
  const [error, setError] = useState<string>()
  const [historyVisible, setHistoryVisible] = useState(false)

  const loadPromoter = useCallback(async (initial = false) => {
    try {
      const response = await PartnerApiRepository.detail(promoterId)
      setPromoter(response.data.data?.promoter)
      setError(undefined)
    } catch (err) {
      if (initial) setError(err.message)
      else message.error(err.message)
    }
  }, [promoterId])

  const savePartial = async (body: PartnerUpdateBody) => {
    await PartnerApiRepository.update(promoterId, body)
    message.success('Informações salvas com sucesso')
    await loadPromoter()
  }

  useEffect(() => {
    setPromoter(undefined)
    loadPromoter(true)
  }, [promoterId, loadPromoter])

  if (error) return <SettingsCard><Empty description={error} /></SettingsCard>
  if (!promoter) return <SettingsCard><Skeleton active /></SettingsCard>

  return (
    <>
      <SettingsHistory
        visible={historyVisible}
        onChangeVisible={() => setHistoryVisible(prev => !prev)}
        title="Histórico de credenciais de API"
        description={`Alterações feitas em ${promoter.name}`}
      >
        <PartnerApiLogs promoterId={promoter._id} />
      </SettingsHistory>

      <SettingsCard.Header
        className="settings-card--align-start"
        title={promoter.name}
        description={`${promoter.email}${promoter.cnpj ? ` · CNPJ ${masks(promoter.cnpj, 'cnpj')}` : ''}`}
      />

      <PartnerTokenSection
        promoter={promoter}
        onSave={savePartial}
        onReload={() => loadPromoter()}
        onOpenHistory={() => setHistoryVisible(true)}
      />
      <ServicesSection promoter={promoter} onSave={savePartial} />
      <CallbackSection promoter={promoter} onSave={savePartial} />
      <CallbackFieldsSection promoter={promoter} onSave={savePartial} />
    </>
  )
}
